import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { blueDark02, blueLink, grayDark03, grayDark06 } from '../../../styles/colors';
import { ClickableRow } from '../../../styles/common.styles';
import { CustomizedTable } from '../../common/table/CustomTable.styles';

export const TagListContainer = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const TagsTableSpace = styled(Space)`
    margin: 4px 0 16px 0;
    align-items: end;
    width: 100%;
    justify-content: space-between;
    &.shift-down {
        margin-top: 32px;
    }
`;

export const TagTable = styled(CustomizedTable) <{ readOnly: boolean }>`
    padding-top: 11px;
    .ant-table-thead > tr > th {
        background: unset;
        border-bottom: 1px solid ${grayDark06};
        font-family: 'Proxima N W15 Bold';
        font-weight: normal;
        font-size: 10px;
        line-height: 12px;
        text-transform: uppercase;
        color: ${blueDark02};
        vertical-align: bottom;
        &::before {
            content: unset !important;
        }
    }
    .ant-table-tbody > tr > td {
        border-bottom: none;
        background: none;
    }
    .ant-table-tbody > tr.ant-table-row-selected:hover > td {
        background: none !important;
    }
    .ant-table-tbody > tr:hover:not(.ant-table-row-selected) > td {
        background: none;
    }
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td, .ant-table tfoot > tr > th, .ant-table tfoot > tr > td {
        padding: 8px 8px;
    }
    .ant-table-thead > tr > th:nth-child(1),
    .ant-table-tbody > tr > td:nth-child(1) {
        padding: 8px 0px;
        text-align: left;
    }

    .ant-table-thead > tr > th:nth-child(2),
    .ant-table-tbody > tr > td:nth-child(2) {
        padding-right: 0px;
        padding-left: ${({ readOnly }) => (readOnly ? '6px' : '1px')};
    }
    .ant-table-tbody > tr > td:nth-child(3) {
        padding-left: ${({ readOnly }) => (readOnly ? '8px' : '0px')};
    }
`;

export const TagGroup = styled('div')`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
`;

export const UnselectAllButton = styled(ClickableRow)`
    white-space: nowrap;
    color: ${blueLink};
    font-family: 'Proxima Nova';
`;

export const TagDropdownOption = styled('span')`
    display: flex;
    margin-left: 11px;
    align-items: center;
    gap: 8px;
`;

export const EditableTagOption = styled('span')`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const TableRow = styled(Typography.Text)`
    color: ${grayDark03};
    font-family: "Proxima Nova";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;

     &.text-bold {
        font-family: "Proxima N W15 Bold";
    }
`;

export const TableRowLink = styled(TableRow)`
    cursor: pointer;
    color: ${blueLink};

    &: hover {
        text-decoration: underline;
    }
    &.text-bold {
        font-family: "Proxima N W15 Bold";
        font-size: 400;
    }
`;